export enum ProviderType {
  AWS = 'aws',
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
  UNSPLASH = 'unsplash'
}
